import { render, staticRenderFns } from "./ShiftAlertBanner.vue?vue&type=template&id=5e0af00f&scoped=true&"
import script from "./ShiftAlertBanner.vue?vue&type=script&lang=js&"
export * from "./ShiftAlertBanner.vue?vue&type=script&lang=js&"
import style0 from "./ShiftAlertBanner.vue?vue&type=style&index=0&id=5e0af00f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0af00f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VAlert,VProgressLinear})
